// Baseball rookie status, the same rule the Rookie of the Year award uses (processAwards.ts): a player stays a rookie
// until the regular season in which his cumulative MAJOR LEAGUE at-bats reach 130 or his outs pitched reach 150
// (scaled by season length). Minor league years, the draft year, call-ups, demotions and trades don't consume it:
// only big-league regular-season stat rows count.
export const ROOKIE_AB = 130;
export const ROOKIE_OUTS = 150;

type Row = { season: number; playoffs: boolean; pa?: number; bb?: number; hbp?: number; sf?: number; outs?: number };

// AB isn't stored on stat rows; it's derived the same way processPlayerStats.baseball does
const atBats = (row: Row) => (row.pa ?? 0) - (row.bb ?? 0) - (row.hbp ?? 0) - (row.sf ?? 0);

/** Still a rookie at the start of `season`: hasn't crossed either threshold in any earlier big-league season. */
export const isRookieEligibleBaseball = (rows: Row[], season: number, cutoffFactor = 1) => {
	let ab = 0;
	let outs = 0;
	for (const row of [...rows].sort((a, b) => a.season - b.season)) {
		if (row.playoffs || row.season >= season) {
			continue;
		}
		ab += atBats(row);
		outs += row.outs ?? 0;
		if (ab >= ROOKIE_AB * cutoffFactor || outs >= ROOKIE_OUTS * cutoffFactor) {
			return false;
		}
	}
	return true;
};
